<template>
    <div class="szyz">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <template v-if="szyzStatus==1">
                <div class="user_info">
                    <div class="left">
                        <img :src="userInfo.portrait"
                             class="avatar"
                             alt="">
                        <div class="info">
                            <strong>{{userInfo.real_name}}</strong>
                            <p>{{userInfo && userInfo.units &&userInfo.units[0]&& userInfo.units[0].school_name || '暂未加入班级'}}</p>
                        </div>
                    </div>
                    <div class="logout"
                         @click="logout">
                        退出
                    </div>
                </div>
                <div class="sf_active"
                     @click="handleJump('/activity/2023shujia/index')">
                    <img src="./img/banner7.png" />
                </div>
                <div class="sf_active mt24"
                     @click="handleJump('/activity/sf_clock/index')">
                    <img src="./img/banner5.png" />
                </div>
                <div class="sf_active mt24"
                     @click="handleJump('/activity/2023sfhd/select_chapter')">
                    <img src="./img/banner1.png" />
                </div>
                <div class="release-personal"
                     v-if="hasSf">
                    <div class="title">
                        发布爱尚书法
                    </div>
                    <div class="item"
                         v-for="(item,index) in typeList"
                         @click="handleJump(item.path)"
                         :key="index">
                        <img :src="item.iconUrl"
                             class="type-pic"
                             alt="">
                        <div class="text">
                            <div>
                                <h3>{{item.name}}</h3>
                                <p>{{item.info}}</p>
                            </div>
                            <img src="./img/icon_right.png"
                                 alt="">
                        </div>
                    </div>
                </div>
                <div class="release-personal"
                     v-if="hasBc">
                    <div class="title">
                        发布爱尚编程
                    </div>
                    <div class="item"
                         v-for="(item,index) in typeList2"
                         @click="handleJump(item.path)"
                         :key="index">
                        <img :src="item.iconUrl"
                             class="type-pic"
                             alt="">
                        <div class="text">
                            <div>
                                <h3>{{item.name}}</h3>
                                <p>{{item.info}}</p>
                            </div>
                            <img src="./img/icon_right.png"
                                 alt="">
                        </div>
                    </div>
                </div>
                <div class="release-personal"
                     v-if="hasMx">
                    <div class="title">
                        发布爱尚模型
                    </div>
                    <div class="item"
                         v-for="(item,index) in typeList3"
                         @click="handleJump(item.path)"
                         :key="index">
                        <img :src="item.iconUrl"
                             class="type-pic"
                             alt="">
                        <div class="text">
                            <div>
                                <h3>{{item.name}}</h3>
                                <p>{{item.info}}</p>
                            </div>
                            <img src="./img/icon_right.png"
                                 alt="">
                        </div>
                    </div>
                </div>
                <div class="statistics">
                    <div class="statistics_title"><span class="title_icon"></span>本月教学统计</div>
                    <div class="school_list"
                         v-if="taskList.length">
                        <div class="school_item"
                             v-for="sc in taskList"
                             :key="sc.school_id">
                            <div class="school_title">{{ sc.school_name }}</div>
                            <ul class="unit_list"
                                v-for="un in sc.data"
                                :key="un.unit_class_id">
                                <li class="unit_item">
                                    <span>{{ un.unit_name }}</span>
                                    <span>作业已发<span class="orange"> {{ un.real_task_count }} </span>次</span>
                                    <span>通知已发<span class="orange"> {{ un.real_mes_count }} </span>次</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="btm_tips">
                    目前仅支持素质E站学科的作业发布，如果您需要发布其他学科作业，请使用<a href="http://m.tbkt.cn/">同步课堂</a>APP
                </div>

            </template>
            <template v-else>
                <teaTask></teaTask>
            </template>
            <div class="btm-area">
                <div @click="changeActive(1)"
                     :class="szyzStatus==1?'active':''">
                    <img src="./img/icon-home.png"
                         alt="">
                    <img src="./img/icon-home-hover.png"
                         class="hover"
                         alt="">
                    <p>首页</p>
                </div>
                <div @click="verificationVisible = true">
                    <img src="./img/icon_server.png"
                         alt="">
                    <p>服务</p>
                </div>
                <div @click="changeActive(2)"
                     :class="szyzStatus==2?'active':''">
                    <img src="./img/icon-done.png"
                         alt="">
                    <img src="./img/icon-done-hover.png"
                         class="hover"
                         alt="">
                    <p>检查作业</p>
                </div>
            </div>
            <verification-code :phoneNumber="userPhone"
                               :visible.sync="verificationVisible"
                               @success="verificationSuccess"></verification-code>
        </template>
    </div>
</template>

<script>
import loadings from "COMPONENTS/base/loadingS.vue";
import teaTask from "./taskList.vue";
import verificationCode from "COMPONENTS/VerificationCode.vue";
export default {
    components: {
        loadings,
        teaTask,
        verificationCode
    },
    data () {
        return {
            szyzStatus: this.$store.state.qualityStation.szyzStatus,//1;首页，2：完成情况
            loading: true,
            userInfo: '',
            userPhone: "",
            typeList: [{
                name: "书法同步练习",
                info: "与教材课程同步",
                iconUrl: require("./release/img/calligraphy01.png"),
                path: '/qualityStation/tea/select_chapter'
            },
            {
                name: "书法作品展示",
                info: "上传并展示书法作品",
                iconUrl: require("./release/img/calligraphy03.png"),
                path: '/qualityStation/require'
            },
            {
                name: "应用提醒",
                info: "",
                iconUrl: require("./release/img/icon-class-reminder.png"),
                path: '/classReminder/index'
            }],
            typeList2: [{
                name: "初级课程",
                info: "学习编程基础",
                iconUrl: require("./release/img/programming01.png"),
                path: '/qualityStation/select_video/12/11?title=初级课程'
            },
            {
                name: "中级课程",
                info: "进一步了解编程",
                iconUrl: require("./release/img/programming02.png"),
                path: '/qualityStation/select_video/12/12?title=中级课程'
            },
            {
                name: "高级课程",
                info: "深入学习编程",
                iconUrl: require("./release/img/programming03.png"),
                path: '/qualityStation/select_video/12/13?title=高级课程'
            }],
            typeList3: [{
                name: "航天模型",
                info: "了解飞行原理",
                iconUrl: require("./release/img/model03.png"),
                path: '/qualityStation/select_video/13/23?title=航天模型'
            },
            {
                name: "车辆模型",
                info: "了解运动原理",
                iconUrl: require("./release/img/model04.png"),
                path: '/qualityStation/select_video/13/24?title=车辆模型'
            }, {
                name: "建筑模型",
                info: "体验建筑之美",
                iconUrl: require("./release/img/model01.png"),
                path: '/qualityStation/select_video/13/21?title=建筑模型'
            },
            {
                name: "桥梁模型",
                info: "了解桥梁结构",
                iconUrl: require("./release/img/model02.png"),
                path: '/qualityStation/select_video/13/22?title=桥梁模型'
            },
            ],
            hasSf: false,
            hasBc: false,
            hasMx: false,
            verificationVisible: false,
            taskList: []
        }
    },
    created () {
        localStorage.removeItem('chinese_send_ok');
        this.$http.post(API_URL_BASE_API + '/account/profile/').then((res) => {
            if (res.data.response === 'ok') {
                let r = this.userInfo = res.data.data;
                this.userPhone = res.data.data.phone;
                res.data.data.units.forEach(e => {
                    if (e.sid == 11) {
                        this.hasSf = true //有书法
                    } else if (e.sid == 12) {
                        this.hasBc = true //有编程
                    } else if (e.sid == 13) {
                        this.hasMx = true //有模型
                    }
                });
                this.loading = false
                localStorage.setItem('info', JSON.stringify(r));
                this.$store.commit('setLoading', false);
            }
        })
        this.$http.post(API_URL_CONFIG_API + '/api/new/home/extra/', { user_type: 3 }).then((res) => {
            res = res.data;
            if (res.response === 'ok') {
                this.taskList = res.data.task_num_new;
            }
        })
    },
    mounted () {
        //修改页面title
        document.title = '素质E站'
    },
    methods: {
        /**路由跳转 */
        handleJump (path) {
            this.$router.push(path)
        },
        /**底部tab切换 */
        changeActive (e) {
            this.szyzStatus = e
            this.$store.commit('setSzyzStatus', e)
            window.scrollTo(0, 0);
        },
        verificationSuccess () {
            location.href = VUE_URL_GIFT + "/gift?from_task=1&tbkt_token=" + localStorage.getItem("Tbkt-Token");
        },
        /**退出登录 */
        logout () {
            localStorage.clear();
            location.href = WAP_URL + '/common/login/?user_type=3&exit=1';
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.szyz {
    padding-bottom: 100px / $ppr;
}
.head_tit {
    font-size: 30px / $ppr;
    color: #0e0e0e;
    text-align: center;
    padding: 30px / $ppr;
    background: #fff;
    font-weight: bold;
    border-bottom: 1px / $ppr solid #eaeaea;
}
.user_info {
    background: #fff;
    padding: 40px / $ppr 30px / $ppr;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
        display: flex;
        align-items: center;
        .avatar {
            width: 100px / $ppr;
            height: 100px / $ppr;
            border-radius: 100%;
            margin-right: 20px / $ppr;
        }
        .info {
            strong {
                font-weight: bold;
                font-size: 36px / $ppr;
                display: block;
                margin-bottom: 10px / $ppr;
                color: #191919;
            }
            p {
                font-size: 24px / $ppr;
                color: #999999;
            }
        }
    }
    .logout {
        font-size: 20px / $ppr;
        color: #ff8c55;
        background: #fff2ec;
        padding: 11px / $ppr 50px / $ppr;
        border-radius: 48px / $ppr;
        cursor: pointer;
    }
}

.release-personal {
    background: #fff;
    margin: 0 0 24px / $ppr;
    .title {
        font-size: 36px / $ppr;
        color: #333;
        font-weight: bold;
        line-height: 96px / $ppr;
        padding-left: 20px / $ppr;
        &:before {
            content: "";
            display: inline-block;
            width: 6px / $ppr;
            height: 34px / $ppr;
            background: #5e89ef;
            border-radius: 2px / $ppr;
            vertical-align: middle;
            margin-right: 10px / $ppr;
            margin-top: -3px / $ppr;
        }
    }
    .item {
        display: flex;
        align-items: center;
        padding: 34px / $ppr 30px / $ppr;
        border-top: 1px / $ppr solid #e8e8e8;
        .type-pic {
            width: 56px / $ppr;
        }
        .text {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 25px / $ppr;
            h3 {
                font-size: 30px / $ppr;
                color: #333;
                font-weight: normal;
                margin-bottom: 10px / $ppr;
            }
            p {
                color: #999;
                font-size: 24px / $ppr;
            }
            img {
                width: 16px / $ppr;
            }
        }
    }
}
.statistics {
    padding: 0 24px / $ppr;
    background-color: #fff;
    .statistics_title {
        padding-top: 30px / $ppr;
        height: 44px / $ppr;
        line-height: 44px / $ppr;
        color: #5e89ef;
        font-size: 36px / $ppr;
        font-weight: bold;
        .title_icon {
            display: inline-block;
            width: 40px / $ppr;
            height: 40px / $ppr;
            background-size: 100% 100%;
            vertical-align: middle;
            margin-top: -6px / $ppr;
            margin-right: 15px / $ppr;
            background-image: url("./img/statistics.png");
        }
    }
    .school_list {
        .school_item {
            padding-top: 19px / $ppr;
            .school_title {
                line-height: 72px / $ppr;
                font-size: 28px / $ppr;
                font-weight: bold;
            }
            .unit_list {
                padding: 0 20px / $ppr 10px / $ppr;
                .unit_item {
                    display: flex;
                    justify-content: space-between;
                    height: 65px / $ppr;
                    align-items: center;
                    font-size: 28px / $ppr;
                    color: #999;
                    .orange {
                        font-weight: bold;
                        color: #f60;
                    }
                }
            }
        }
    }
}
.btm_tips {
    padding: 40px / $ppr;
    font-size: 24px / $ppr;
    color: #999999;
    line-height: 1.7;
    text-align: center;
    a {
        color: #5e89ef;
    }
}
.btm-area {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    border-top: 1px / $ppr solid #e8e8e8;
    display: flex;
    padding: 14px / $ppr 0 10px / $ppr;
    &:before {
        content: "";
        position: absolute;
        width: 1px;
        height: 100%;
        top: 0;
        left: 50%;
        z-index: 22;
    }
    div {
        flex: 1 0 0;
        text-align: center;
        img {
            width: 40px / $ppr;
            display: block;
            margin: 0 auto;
            margin-bottom: 10px / $ppr;
        }
        p {
            color: #aaa;
            font-size: 20px / $ppr;
            line-height: 1;
        }
    }

    .active {
        img {
            display: none;
        }
        .hover {
            display: block;
        }
        p {
            color: #5e89ef;
        }
    }
    .hover {
        display: none;
    }
}
.sf_active {
    width: 100%;
    padding: 0 24px / $ppr;
    box-sizing: border-box;
    background: #fff;
    img {
        display: block;
        width: 100%;
    }
}
.mt24 {
    margin-top: 24px / $ppr;
}
</style>